import { Badge } from "@/components/ui/badge";
import { X } from "lucide-react";

interface BadgeItem {
  id: string;
  label: string;
}

interface BadgeListProps {
  items: BadgeItem[];
  selectedId?: string | null;
  onSelect?: (id: string) => void;
  onDelete?: (id: string) => void;
}

export function BadgeList({
  items,
  selectedId,
  onSelect,
  onDelete,
}: BadgeListProps) {
  return (
    <div className="flex flex-wrap gap-2">
      {items.map((item) => {
        const isSelected = item.id === selectedId;

        return (
          <Badge
            key={item.id}
            variant={isSelected ? "default" : "secondary"}
            className="gap-1.5 pr-1 cursor-pointer transition-colors h-8"
            onClick={() => onSelect?.(item.id)}
          >
            <span>{item.label}</span>
            <button
              onClick={(e) => {
                e.stopPropagation();
                onDelete?.(item.id);
              }}
              className="rounded-sm hover:bg-accent hover:text-accent-foreground p-0.5 transition-colors"
              aria-label={`Delete ${item.label}`}
            >
              <X className="h-3 w-3" />
            </button>
          </Badge>
        );
      })}
    </div>
  );
}
